import { createClient } from "@sanity/client";

export const sanity = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: "2025-10-18",
  useCdn: true,
});
